<div class="rx-card" [class.read-only]="isReadOnly$ | async">
    <div class="rx-card-title notes-title">
        <div class="rx-title-row rx-app-flex-container-row rx-app-flex-container-row--justify-space-between rx-app-flex-container-row--align-center">
            <div class="aligntech-notes-title rx-card-title-text">{{ 'AligntechNotes.AligntechNotes' | translate }}</div>
        </div>
    </div>
    <div class="rx-card-body notes-card-body">
        <form [formGroup]="alignTechNotesForm">
            <div class="create-note rx-app-flex-container-row" *ngIf="!(this.isReadOnly$ | async)">
                <div class="note-form-field rx-app-flex--full">
                    <textarea
                        id="new-note"
                        [formControl]="newNote"
                        (focus)="focusNotes($event)"
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="3"
                        [placeholder]="'NotesSection.AddNote' | translate"
                        class="note-textarea note-textarea--outline"
                    >
                    </textarea>
                </div>
            </div>
            <ng-container formArrayName="alignTechNotes">
                <div
                    *ngFor="let note of alignTechNotes.controls; index as i"
                    class="mt-4 note-row rx-app-flex-container-row rx-app-flex-container-row--align-center"
                    [class.not-editable]="!(i | mapper: canDelete.bind(this))"
                >
                    <div class="rx-app-flex rx-app-flex-container-column rx-app-flex-container-column--justify-center">
                        <div
                            *ngIf="note.value.createdByName || note.value.dateCreated"
                            id="note-title"
                            class="note-title note-title-position"
                        >
                            <span [id]="'note-created-by-name-' + i">{{ note.value.createdByName }}</span>
                            <div class="rx-app-flex-container-row rx-app-flex-container-row--justify-space-between rx-app-flex-container-row--align-center">
                                <span class="date-and-time mr-4">
                                    {{ note.value.dateCreated | date: (dateFormat$ | async) }}
                                    <span class="line-separator">|</span>
                                    {{ note.value.dateCreated | date: 'shortTime' }}</span
                                >
                                <span>
                                    <span *ngIf="i | mapper: canEdit.bind(this)" [id]="'edit-note-' + i" class="edit-note" (click)="editNote(i)">
                                        <mat-icon svgIcon="pencil_icon"></mat-icon>
                                    </span>
                                    <span *ngIf="i | mapper: canDelete.bind(this)" [id]="'remove-note-' + i" class="remove-note" (click)="removeNote(i)">
                                        <mat-icon svgIcon="trash_icon"></mat-icon>
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div class="note-content rx-app-flex-container-row">
                            <div class="note-form-field rx-app-flex--full" [class.disabled]="!isInEditableMode(i)">
                                <ng-container [formGroup]="note">
                                    <textarea
                                        ngDefaultControl
                                        #noteinput
                                        (focus)="focusNotes($event)"
                                        (blur)="blurNotes()"
                                        formControlName="content"
                                        [id]="'notes-input-' + i"
                                        class="notes-input note-textarea"
                                        autocomplete="off"
                                        cdkTextareaAutosize
                                        cdkAutosizeMinRows="1"
                                        [placeholder]="'NotesSection.AddNotes' | translate"
                                        [disabled]="!isInEditableMode(i)"
                                    ></textarea>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </form>
    </div>
</div>
